module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalVisible === 'code') ? _c('layout-general', {
    on: {
      "close": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.export')) + " box")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('modal.code.step_one')))]), _vm._v(" "), _c('textarea', {
    staticClass: "code-textarea",
    attrs: {
      "readonly": ""
    },
    on: {
      "click": function($event) {
        return $event.target.select()
      }
    }
  }, [_vm._v(_vm._s(_vm.codeScript))]), _vm._v(" "), _c('copy-button', {
    attrs: {
      "text": _vm.codeScript
    }
  })], 1), _vm._v(" "), (_vm.showButtonAttribute()) ? _c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('modal.code.step_two')) + " " + _vm._s(_vm.$t('modal.code.step_three')))]), _vm._v(" "), _c('textarea', {
    staticClass: "code-textarea",
    attrs: {
      "readonly": ""
    },
    on: {
      "click": function($event) {
        return $event.target.select()
      }
    }
  }, [_vm._v(_vm._s(_vm.codeButtonAttribute))]), _vm._v(" "), _c('copy-button', {
    attrs: {
      "text": _vm.codeButtonAttribute
    }
  })], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-35f4c654!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Code.vue
 ** module id = 799
 ** module chunks = 1
 **/